class CandleGenerator {
    constructor() {
        this.selectedImageIndex = 0;
        this.loadedImages = [];
        this.imageGenerated = false;
        this.isGenerating = false;
        
        this.CANDLE_IMAGES = [
            'https://cdn.shopify.com/s/files/1/0815/1846/1255/files/bougie_deuil_virtuelle.jpg?v=1752223884',
            'https://cdn.shopify.com/s/files/1/0815/1846/1255/files/bougie_deuil_virtuelle_2.jpg?v=1752223875'
        ];

        this.initElements();
        this.bindEvents();
        this.preloadImages();
    }

    initElements() {
        this.nameInput = document.getElementById('nameInput');
        this.generateBtn = document.getElementById('generateBtn');
        this.resetBtn = document.getElementById('resetBtn');
        this.downloadBtn = document.getElementById('downloadBtn');
        this.canvas = document.getElementById('candleCanvas');
        this.ctx = this.canvas.getContext('2d');
        this.placeholder = document.getElementById('placeholder');
        this.loading = document.getElementById('loading');
        this.downloadSection = document.getElementById('downloadSection');
        this.imageOptions = document.querySelectorAll('.image-option');
    }

    bindEvents() {
        this.generateBtn.addEventListener('click', () => this.generateCandle());
        this.resetBtn.addEventListener('click', () => this.resetGenerator());
        this.downloadBtn.addEventListener('click', () => this.downloadImage());
        
        this.imageOptions.forEach((option, index) => {
            option.addEventListener('click', () => this.selectImage(index));
        });

        this.nameInput.addEventListener('input', () => this.updateGenerateButton());
        this.nameInput.addEventListener('keypress', (e) => {
            if (e.key === 'Enter' && !this.generateBtn.disabled) {
                this.generateCandle();
            }
        });
    }

    selectImage(index) {
        this.selectedImageIndex = index;
        this.imageOptions.forEach((option, i) => {
            option.classList.toggle('selected', i === index);
        });
    }

    updateGenerateButton() {
        const hasName = this.nameInput.value.trim().length > 0;
        const hasImages = this.loadedImages.length > 0;
        this.generateBtn.disabled = !hasName || !hasImages || this.isGenerating;
    }

    preloadImages() {
        this.loading.style.display = 'flex';
        this.placeholder.style.display = 'none';
        
        let loadedCount = 0;
        
        this.CANDLE_IMAGES.forEach((url, index) => {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            
            img.onload = () => {
                this.loadedImages[index] = img;
                loadedCount++;
                
                if (loadedCount === this.CANDLE_IMAGES.length) {
                    this.loading.style.display = 'none';
                    this.placeholder.style.display = 'flex';
                    this.updateGenerateButton();
                }
            };
            
            img.onerror = () => {
                console.error(`Erreur de chargement de l'image: ${url}`);
                loadedCount++;
                
                if (loadedCount === this.CANDLE_IMAGES.length) {
                    this.loading.style.display = 'none';
                    this.placeholder.style.display = 'flex';
                }
            };
            
            img.src = url;
        });
    }

    generateCandle() {
        const name = this.nameInput.value.trim();
        
        if (!name || !this.loadedImages[this.selectedImageIndex]) {
            alert('Veuillez entrer un nom');
            return;
        }

        this.isGenerating = true;
        this.updateGenerateButton();
        this.updateGenerateButtonText(true);

        setTimeout(() => {
            const baseImage = this.loadedImages[this.selectedImageIndex];
            
            // Définir la taille du canvas
            this.canvas.width = baseImage.width;
            this.canvas.height = baseImage.height;
            
            // Dessiner l'image de base
            this.ctx.drawImage(baseImage, 0, 0);
            
            // Configuration du texte
            const fontSize = Math.max(32, baseImage.width * 0.05);
            this.ctx.font = `bold ${fontSize}px Georgia, serif`;
            this.ctx.fillStyle = '#2c3e50';
            this.ctx.textAlign = 'center';
            this.ctx.textBaseline = 'middle';
            
            // Contour blanc
            this.ctx.strokeStyle = 'white';
            this.ctx.lineWidth = 4;
            this.ctx.lineJoin = 'round';
            this.ctx.miterLimit = 2;
            
            // Position du texte
            const textX = this.canvas.width / 2;
            const textY = fontSize + 30;
            
            // Dessiner le contour blanc puis le texte
            this.ctx.strokeText(name, textX, textY);
            this.ctx.fillText(name, textX, textY);
            
            // Mettre à jour l'interface
            this.canvas.style.opacity = '1';
            this.placeholder.style.display = 'none';
            this.downloadSection.style.display = 'block';
            this.resetBtn.style.display = 'inline-flex';
            
            this.imageGenerated = true;
            this.isGenerating = false;
            this.updateGenerateButton();
            this.updateGenerateButtonText(false);
        }, 100);
    }

    updateGenerateButtonText(isGenerating) {
        if (isGenerating) {
            this.generateBtn.innerHTML = `
                <div class="spinner"></div>
                Génération...
            `;
        } else {
            this.generateBtn.innerHTML = `
                <svg class="btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"/>
                </svg>
                Créer la bougie
            `;
        }
    }

    downloadImage() {
        if (!this.canvas) return;
        
        const link = document.createElement('a');
        const name = this.nameInput.value.trim().replace(/\s+/g, '-').toLowerCase();
        link.download = `bougie-deuil-${name}.png`;
        link.href = this.canvas.toDataURL('image/png');
        link.click();
    }

    resetGenerator() {
        this.nameInput.value = '';
        this.imageGenerated = false;
        this.canvas.style.opacity = '0.3';
        this.placeholder.style.display = 'flex';
        this.downloadSection.style.display = 'none';
        this.resetBtn.style.display = 'none';
        
        // Effacer le canvas
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        
        this.updateGenerateButton();
    }
}

// Initialiser le générateur quand le DOM est chargé
document.addEventListener('DOMContentLoaded', () => {
    new CandleGenerator();
});